import React from "react";

export interface InputProps
  extends React.InputHTMLAttributes<HTMLInputElement> {
  error?: string;
}

// TODO: add succes and error states and icon to input
export const Input = React.forwardRef<HTMLInputElement, InputProps>(
  ({ className, children, error, ...other }, ref) => {
    return (
      <>
        <input
          ref={ref}
          className={`${className} block text-left rounded-lg border p-2.5 text-sm focus:border-green-500 focus:ring-1 focus:outline-none focus:ring-green-500 ${
            error
              ? "border border-red-500 bg-red-50 text-red-900 placeholder-red-700"
              : "border-green-500 bg-gray-50 text-gray-900"
          }`}
          {...other}
        />
        {error && (
          <div className="px-1 text-xs w-full text-red-500">{error}</div>
        )}
      </>
    );
  }
);

Input.displayName = "Input";
